<template>
  <svg
    width="400"
    height="200"
    viewBox="0 0 400 200"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    style="z-index: 1"
    preserveAspectRatio="none"
  >
    <title>{{ this.value }}</title>
    <defs id="defid">
      <linearGradient
        id="tdl-KeyGradient"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="0"
        y2="200"
      >
        <stop style="stop-opacity: 1; stop-color: #e3e2e2" offset="0.50" />
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0.9" />
      </linearGradient>
      <linearGradient
        id="tdl-WaterGradient"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="0"
        y2="200"
      >
        <stop style="stop-opacity: 1; stop-color: #23c2df" offset="0" />
        <stop style="stop-opacity: 1; stop-color: blue" offset="0.9" />
      </linearGradient>
      <linearGradient
        id="tdl-OilGradient"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="0"
        y2="200"
      >
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0.20" />
        <stop style="stop-opacity: 1; stop-color: black" offset="0.9" />
      </linearGradient>
      <clipPath id="tdl-cut">
        <path d="M 50 0 H 350 C 415 10, 415 190 350 200 H 50 C -15 190 -15 10 50 0 Z" />
      </clipPath>
      <text id="caption" x="50%" y="50"></text>
      <!--   class="oil-level_value oil_value -->
    </defs>

    <rect
      id="tank"
      descr="WATER"
      y="0"
      width="100%"
      height="100%"
      clip-path="url(#tdl-cut)"
      fill="url(#tdl-KeyGradient)"
    />
    <rect
      id="WATER"
      width="100%"
      height="300px"
      clip-path="url(#tdl-cut)"
      style="fill: url(#tdl-WaterGradient)"
      :y="valueLevelTwo"
    >
      <title>Уровень воды{{ valueLevelTwo }}</title>
    </rect>
     <rect
      id="OIL"
      width="100%"
      height="5%"
      clip-path="url(#tdl-cut)"
      style="fill: url(#tdl-OilGradient)"
      class="oil_value"
      :y="valueLevelTwo"
      min="0"
      max="100"
    >
      <title>Уровень нефти</title>
    </rect>
    <use href="#caption" class="f-small" content-value="Capacity" />
  </svg>
</template>

<script>
import MixinBase from "./mixin-base.js";
export default {
  name: "tank_double_level",
  props: {
    type: { type: Number, default: 1 },
  },
  mixins: [MixinBase],

  computed: {
    valueLevel() {
      return 80 + this.intervalValue + "px";
    },
    intervalValue() {
      const result = 100 - (this.value / 100) * 100;
      return result;
    },
    valueLevelTwo() {
      return !this.value ? 300 : (100 - this.value) * 2 + "px";
    },
  },
};
</script>
